<script setup lang="ts">
import { useRedirectTargets } from "@/composables/useRedirectTargets";
import LoggedOut from "@/layouts/LoggedOut.vue";
import type { redirectSchema } from "@/router/dtos";
import { ref } from "vue";
import { useRouter } from "vue-router";
import * as z from "zod/v4-mini";
import { useVerifyLogin } from "./useVerifyLogin";

const { redirect } = defineProps<{
  redirect: z.infer<typeof redirectSchema>;
}>();

const router = useRouter();

const redirectTarget = useRedirectTargets(redirect);

const code = ref("");
const { verifyLogin, verifyLoginStatus, error } = useVerifyLogin({
  onSuccess: () => router.push(redirectTarget.value ?? { name: "home" }),
});
</script>

<template>
  <LoggedOut>
    <h1>Anmeldecode prüfen</h1>
    <form class="column" @submit.prevent="verifyLogin(code)">
      <div class="column column-md">
        <label for="code" class="visually-hidden">Anmeldecode</label>
        <input
          id="code"
          v-model="code"
          type="text"
          name="code"
          required
          minlength="6"
          maxlength="6"
          pattern="[a-zA-Z0-9]+"
          autofocus
          placeholder="Anmeldecode"
          autocomplete="one-time-code"
          :aria-invalid="verifyLoginStatus === 'error'"
        />
        <small v-if="verifyLoginStatus === 'error'">{{ error?.message }}</small>
        <button class="button" type="submit">Prüfen</button>
      </div>
    </form>
  </LoggedOut>
</template>

<style scoped>
button[type="submit"] {
  width: 100%;
  justify-content: center;
}
</style>
